import React, { useEffect, useState } from 'react';
import CommonInput from './commonInput';
import CommonDropdown from './commonDropdown';
import CommonButton from './commonButton';
import CommonRadioGroup from './commonRadioGroup';
import CommonDateRange from './commonDateRange';
import Otp from './otp-input';
import { useLoader } from "./LoaderProvider";
import CommonLoader from './commonLoader';
import LeftArrow from '../../assests/images/left-arrow.svg'
import CountdownTimer from '../../common/component/CountDownTimer';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { sendOtp, verifyOTP } from "../../service/action/actioncreator/LoginAction/LoginAction";
import { useTranslation } from "react-i18next";


const CommonOtpModal = ({
  timer,
  setTimer,
    isOpen,
    title = "Modal Title",
    onClose,
    onSubmit,
    formFields = [],
    control,
    register,
    errors,
    onReset,
    modalFlag="",
    verification,
    otpOptions,
    validationFn,
    setValue,
    getValue,
    clearErrors,
    defaultValue,
    backArrowFn,
    onBack,
    authenticationdata,
    userId

  }) => {


    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [count, setCount]=useState(false)
    const [timers,setTimers] =useState(timer);
    const [otpCodeFlag, setOtpCodeFlag] = useState(false);
    const [otpSelectionFlag, setOtpSelectionFlag] = useState(false);
    const { t } = useTranslation("translation");
    const {
      showLoader,
      hideLoader,
      loadingStepper,
      showStepperLoader,
      hideStepperLoader,
    } = useLoader();

    useEffect(()=>{
      timers && setTimers(timers)
    },[timers])

    if (!isOpen) return null;

    const resetOtpFn=()=>{
          // reset()
          let navigateFlag = false;
          const authenticationType =localStorage?.getItem('authenticationType');
          // const userId = localStorage?.getItem('userId');
          let payload = {
            userId:userId,
            authenticationFor: authenticationdata,
            authenticationType: authenticationType,
          };
          dispatch(sendOtp(
            payload,
            navigate,
            showLoader,
            hideLoader,
            navigateFlag,
            setOtpSelectionFlag,
            setOtpCodeFlag,
            setTimer
          ))
          // setTimer(120);
      
        }

    return (
        <div
        className={`modal fade creator-modal-wrap ${isOpen ? 'show' : ''}`}
        style={{ display: isOpen ? 'block' : 'none' }}
        id="add-field-modal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden={!isOpen}
        data-backdrop="false"
        data-keyboard="false" 
        >
      <div className="modal-dialog modal-lg modal-dialog-centered">
        <div className="modal-content">
          <form onSubmit={onSubmit} className="form-grid">
          {loadingStepper && <CommonLoader loading={loadingStepper} />}
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {title}
              </h5>
              {/* <img src={LeftArrow} onClick={backArrowFn}/> */}
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              ></button>
            </div>
  
            <div className="modal-body"   style={{
                height: "28vh" ,marginLeft:"6%"
              }}>
  
              <div className="row">
                {verification ? 
              <CommonRadioGroup
                       name="selectedOption"
                       label="Entra nella modalità OTP"
                       options={otpOptions}
                       control={control}
                       errors={errors}
                       register={register}
                       validationFn={validationFn}
                       defaultValue={defaultValue}
                   />
                   :
                   <div className="">   
                   <div className="mb-3">
                   <CountdownTimer initialSeconds={timer} setTimer={setTimer} setCount={setCount} count={count} />
     
                     </div>             
                     <Otp
                       name="otp"
                       setValue={setValue}
                       getValues={getValue}
                       control={control}
                       errors={errors}
                       label={"Enter the Otp sended to your Mail/SMS/Authy apps"}
                       clearErrors={clearErrors}
                       validationFn={validationFn}
                     />     
                      {count && <p className="text-center otp-message mt-4 font-size-fs-6 mt-5">
                       {t("text_link_resend_otp")}{" "}
                     <span className="underline pointer" onClick={resetOtpFn}>{t("text_posting")}</span>
                    </p>}
     
                    </div>
                }
              </div>
                </div>
                <div className="modal-footer p-3 ms-4 text-end">
                {/*   onBack {verification==false && <CommonButton label="Indietro" inputStyle={true}   onClick={onReset}  className="ms-2" variant={"cancel"} />}*/}
                {verification==false && <CommonButton label="Indietro" inputStyle={true}   onClick={onReset}  className="ms-2" variant={"cancel"} />}
                 <CommonButton label={verification ? "Invia OTP" : "Salva"}  onClick={onSubmit} inputStyle={true}   className="ms-2" variant={"success"} />
               
            </div>
          </form>
        </div>
      </div>
      </div>
    );
  };
  export default CommonOtpModal